<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="SeconDeltaSolSlt_1d00"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import SeconDeltaSolSlt_1d00 from '@/device-products/SeconDeltaSolSlt_1d00.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: SeconDeltaSolSlt_1d00, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
